import { FC, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Typography } from '@mui/material';
import { CustomButton, FormTextField } from 'components/shared';
import { RadabankService } from 'utils/services';
import { IRadabankResetPasswordSetRequest } from 'utils/types';
import { resetRadabankPasswordDocumentValidationSchema } from 'utils/validation';
import { RestoreRadabankPasswordStepProps } from '../../data';

export const RestoreRadabankPasswordDocumentStep: FC<RestoreRadabankPasswordStepProps> = ({
	onSaveData,
	initialValues,
	onError,
	className = '',
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const methods = useForm({
		defaultValues: {
			docnumber: '',
		},
		mode: 'onTouched',
		resolver: yupResolver(resetRadabankPasswordDocumentValidationSchema),
	});

	const {
		handleSubmit,
		formState: { isValid },
	} = methods;

	const onSubmit = async (values: Pick<IRadabankResetPasswordSetRequest, 'docnumber'>) => {
		try {
			setIsLoading(true);
			await RadabankService.resetPasswordDocument({ ...initialValues, ...values });
			onSaveData?.({ ...initialValues, ...values });
		} catch (error) {
			onError(error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<FormProvider {...methods}>
			<form className={className} onSubmit={handleSubmit(onSubmit)}>
				<Typography>
					Введіть номер паспорту / ID-картки (без серії, тільки цифри), з яким ви проходили реєстрацію в додатку
				</Typography>
				<FormTextField inputProps={{ inputMode: 'numeric' }} label="Номер паспорту" name="docnumber" />
				<CustomButton type="submit" label="Продовжити" disabled={!isValid} isLoading={isLoading} size="large" />
			</form>
		</FormProvider>
	);
};
